<template lang="html">
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex>
        <v-layout column align-end >
          <date-picker
            class="text-xs-right"
            v-model="time" 
            range
            confirm
            clear
            placeholder="Select a Date Range"
            input-name="time"
            :format="'DD-MM-YYYY'"
            @confirm="formatDates()"
          >
          </date-picker>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <ResponsesByQuestionsSmileys 
              :dates="datesValues"
              :round_id="round_id"
              @endGraphByQuestions="endGraphByQuestions"
            ></ResponsesByQuestionsSmileys>
          </v-flex>
        </v-layout>
        <v-layout row wrap column align-end >
          <v-switch
            v-model="switch1"
            :label="`${switch1 ? 'Groups' : 'Devices'}`"
            large
          ></v-switch>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6>
            <ResponsesDevicesByDays
              :dates="datesValues"
              :type="switch1 ? 'groups' : 'devices'"
              :round_id="round_id"
              @endGraphByDays="endGraphByDays"
              v-if="showGraphByDays"
              ></ResponsesDevicesByDays>
          </v-flex>
          <v-flex xs6>
            <ResponsesDevicesByQuestionSmileys
              :dates="datesValues"
              :type="switch1 ? 'groups' : 'devices'"
              :round_id="round_id"
              v-if="showGraphByDevices"
              @endGraphByDevices="endGraphByDevices"
            ></ResponsesDevicesByQuestionSmileys>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <ResponsesDevicesByHours
              v-if="showGraphByHours"
              :dates="datesValues"
              :round_id="round_id"
            ></ResponsesDevicesByHours>
          </v-flex>
        </v-layout>
      </v-flex>    
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import ResponsesByQuestionsSmileys from '@/components/client/rounds/dashboard/graphs/ResponsesByQuestionsSmileys.vue';
import ResponsesDevicesByDays from '@/components/client/rounds/dashboard/graphs/ResponsesDevicesByDays.vue';
import ResponsesDevicesByQuestionSmileys from '@/components/client/rounds/dashboard/graphs/ResponsesDevicesByQuestionSmileys.vue';
import ResponsesDevicesByHours from '@/components/client/rounds/dashboard/graphs/ResponsesDevicesByHours.vue';

import 'vue2-datepicker/index.css';
export default {
  components: {
    DatePicker,
    ResponsesByQuestionsSmileys,
    ResponsesDevicesByDays,
    ResponsesDevicesByQuestionSmileys,
    ResponsesDevicesByHours
  },
  props: {
    round_id: {
      type: String,
      required: true,
      
    }
  },
  data () {
    return {
      time: ['empty', 'empty'],
      datesValues: { startDate: 'empty', endDate: 'empty' },
      switch1: false,
      showGraphByDays: false,
      showGraphByDevices: false,
      showGraphByHours: false
    };
  },
  computed: {
    ...mapGetters('survey', ['selectedSurvey']),
   
  },
  methods: {
    formatDates () {
      if (this.time[0] !== 'empty' && this.time[1] !== 'empty') {
        this.datesValues.startDate = moment(this.time[0]).format('DD-MM-YYYY');
        this.datesValues.endDate = moment(this.time[1]).format('DD-MM-YYYY');
      }
    },
    endGraphByQuestions () {
      this.showGraphByDays = true;
    },
    endGraphByDays () {
      this.showGraphByDevices = true;
    },
    endGraphByDevices () {
      this.showGraphByHours = true;
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/client/rounds/dashboard/DashboardDevices.vue